import * as React from "react";
import BlockCodingHeader from "../components/Coding/BlockCoding";

export default function Coding() {
  return (
    <main className="min-h-screen pt-24">
      <div className="page-container">
        <h1 className="text-4xl sm:text-5xl font-semibold text-foreground tracking-tight mb-4">
          Coding & Projects
        </h1>
        <p className="text-muted text-lg mb-12 max-w-2xl">
          A collection of my professional experience, school projects, and personal side projects.
          My core focus is building end to end Artifical Intelligence and backend data infrastructure, f
          rom RAG pipelines and MCP servers to scalable APIs and cloud architecture.
        </p>
        <BlockCodingHeader />
      </div>
    </main>
  );
}
